module.exports = __webpack_public_path__ + "static/backup-1b97bd50cee30c8dbf42f8569d4b5a00.png";